import { Link } from "react-router-dom";
import { Sprout } from "lucide-react";
import { Container } from "./common";

export const Footer = () => {
  return (
    <footer className="bg-rc-bg border-t border-rc-border py-14" data-testid="footer">
      <Container>
        <div className="flex flex-col md:flex-row justify-between gap-8">
          <div className="max-w-sm">
            <div className="flex items-center gap-2">
              <Sprout className="w-5 h-5 text-rc-sage" strokeWidth={1.6} />
              <span className="font-serif text-lg text-stone-100">
                Raíz<span className="text-rc-sage"> Commerce</span>
              </span>
            </div>
            <p className="mt-4 text-sm text-stone-500 font-light leading-relaxed">
              Arquitectura territorial regenerativa. Comercio, economía circular y turismo bajo una sola
              gobernanza. Xalapa, Veracruz.
            </p>
          </div>
          <div className="flex gap-12 text-sm">
            <div className="space-y-3">
              <div className="font-mono text-xs uppercase tracking-wider text-stone-600">Navegar</div>
              <a href="/#servicios" className="block text-stone-400 hover:text-rc-sage transition-colors">Servicios</a>
              <a href="/#metodo" className="block text-stone-400 hover:text-rc-sage transition-colors">Método NODO</a>
              <a href="/#biblioteca" className="block text-stone-400 hover:text-rc-sage transition-colors">Biblioteca</a>
              <Link to="/tablero" className="block text-stone-400 hover:text-rc-sage transition-colors">Tablero de impacto</Link>
            </div>
            <div className="space-y-3">
              <div className="font-mono text-xs uppercase tracking-wider text-stone-600">Contacto</div>
              <a href="mailto:raiz.commerce2030@gmail.com" className="block text-stone-400 hover:text-rc-sage transition-colors">Correo</a>
              <a href="https://wa.me/522214125123" target="_blank" rel="noopener noreferrer" className="block text-stone-400 hover:text-rc-sage transition-colors">WhatsApp</a>
              <Link to="/admin" className="block text-stone-600 hover:text-stone-400 transition-colors">Acceso equipo</Link>
            </div>
          </div>
        </div>
        <div className="mt-12 pt-8 border-t border-rc-border flex flex-col sm:flex-row justify-between gap-3 text-xs text-stone-600 font-mono">
          <span>© 2026 Raíz Commerce · Método NODO</span>
          <span>STPS · CORA-681105-G98-0005 · ODS 2 · 8 · 11 · 12 · 17</span>
        </div>
      </Container>
    </footer>
  );
};
